import axios from "axios-config";
import ConsoleHelper from "utils/ConsoleHelper";

export const fetchUsers = async () => {
  const response = await axios.get("/organizations/users");
  return response.data;
};

export const fetchUserInvitations = async () => {
  const response = await axios.get("/organizations/invitations");
  return response.data;
};

export const fetchOrganization = async () => {
  const response = await axios.get("/organizations");
  return response.data;
};

export const fetchBilling = async () => {
  const response = await axios.get("/organizations/billing");
  ConsoleHelper("billing", response.data);
  return response.data;
};

// Cancel a user invitation by ID
export const cancelUserInvitation = async (invitationId) => {
  const response = await axios.delete(
    `/organizations/inviteUser/${invitationId}`
  );
  return response;
};
